// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"4":"356b3519","120":"8f00b0c1","856":"19ab0e07"}[chunkId] + ".js";
};